export default __webpack_public_path__ + "d79c770b76fa42614b3384e1ce9a69a5.svg";